import { useAuth } from '../hooks/useAuth'
import TrackitLogo from '../components/TrackitLogo'

export default function Login() {
  const { login } = useAuth()

  return (
    <div className="min-h-screen bg-[#F0F9FF] flex items-center justify-center">
      <div className="bg-white rounded-3xl shadow-xl max-w-sm w-full text-center overflow-hidden">
        <div className="p-10">
          {/* Animated wordmark - the delivery track draws itself and lands on
              the live node (Danone One corporate font; the brand's primary mark
              for the login screen). */}
          <TrackitLogo className="h-14 mx-auto mb-8" animated />

          <h1 className="text-xl font-bold text-slate-800 mb-2">Welcome to TrackIT</h1>
          <p className="text-slate-500 text-sm mb-8">Sign in with your Danone account to continue</p>

          <button onClick={login} className="w-full btn-primary text-white py-3 rounded-xl font-bold text-sm">
            Sign in with Microsoft
          </button>
        </div>
      </div>
    </div>
  )
}
